var divider_viewer_rtlignore_default = {
  "divider-container": "iHNxY",
  "divider-container--double": "Jjz9C",
  "divider": "R-bIG",
  "divider--single": "_6KWRM",
  "divider--double": "c7EGe",
  "divider--dashed": "IzUH3",
  "divider--dotted": "o7rP7",
  "divider--small": "_47vDh",
  "divider--medium": "vFV14",
  "divider--large": "Ne4Dh",
  "divider--left": "O7eIc",
  "divider--center": "HrXdn",
  "divider--right": "o2EM2",
  "svgFixerContainer": "n0O5C",
  "emptyChar": "EVYl-"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
